/**
 * 文件功能：路由配置文件（Vue Router 4 版本）
 * 输入参数：无（读取各视图组件定义路由表）
 * 输出参数：导出 router 实例供 main.ts 注册
 * 返回值：Router 实例
 * 说明：history 模式路由；meta.showNavbar 控制导航栏显隐。
 *       英语游戏模块已迁移至独立项目（e:\self_work\word_game），此处不再包含相关路由。
 */
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      showNavbar: true, // 显示导航栏
    },
  },
  {
    path: '/self_setting',
    name: 'self_setting',
    component: () => import('../views/SelfSettingView.vue'),
    meta: {
      showNavbar: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: {
      showNavbar: false, // 登录页不显示导航栏
    },
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('../views/BlogView.vue'),
    meta: {
      showNavbar: true,
    },
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('../views/CalendarView.vue'),
    meta: {
      showNavbar: true,
    },
  },
  {
    path: '/pomodoro',
    name: 'pomodoro',
    component: () => import('../views/PomodoroView.vue'),
    meta: {
      showNavbar: true,
    },
  },
  {
    path: '/guest',
    name: 'guest',
    component: () => import('../views/GuestView.vue'),
    // 仅在直接访问 /guest 根路径时重定向到游客首页；
    // 子路由（guest_home / blog_show / guest_about / guest_map）正常停留，不再被强制跳走
    redirect: '/guest/guest_home',
    meta: {
      showNavbar: false,
    },
    children: [
      {
        path: 'guest_map',
        name: 'guest_map',
        component: () => import('../components/MapPage.vue'),
        meta: {
          showNavbar: false,
        },
      },
      {
        path: 'guest_home',
        name: 'guest_home',
        component: () => import('../components/GuestHomePage.vue'),
      },
      {
        // 动态 :id 段使博客 id 持久化在 URL 中，刷新/分享链接后仍可按 id 兜底加载详情
        path: 'blog_show/:id',
        name: 'blog_show',
        component: () => import('../components/BlogShowPage.vue'),
        props: true,
        meta: {
          showNavbar: true,
        },
      },
      {
        path: 'guest_about',
        name: 'guest_about',
        component: () => import('../components/GuestAboutPage.vue'),
        props: true,
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
